import MapFeature from './MapFeature'

/**
 * Refreshes data of a map source in a certain interval or on demand.
 */
export default class SourceRefresh extends MapFeature {

    /** @type {string} */
    _sourceId

    /** @type {number} */
    _interval

    /** @type {number} Timeout ID */
    _refreshTimeout

    constructor(sourceId, interval) {
        super()

        this._sourceId = sourceId
        this._interval = interval

        this._handleMapData = this._handleMapData.bind(this)
        this.refresh = this.refresh.bind(this)
    }

    /**
     * Refresh the source now.
     */
    refresh() {
        if (this._map) {
            // Clear the tile cache for the source
            this._map.style.sourceCaches[this._sourceId].clearTiles()

            // Load the new tiles for the current viewport (map.transform -> viewport)
            this._map.style.sourceCaches[this._sourceId].update(this._map.transform)

            // Force a repaint, so that the map will be repainted without movements
            this._map.triggerRepaint()
        }
    }

    _onAdd(map) {
        map.on('data', this._handleMapData)
    }

    _onRemove(map) {
        map.off('data', this._handleMapData)
    }

    /**
     * @param {import("maplibre-gl").MapDataEvent} e
     */
    _handleMapData(e) {
        if (e.sourceId === this._sourceId) {
            this._setRefreshTimeout()
        }
    }

    /**
     * Set a refresh timeout from now on, cancel previous timeout.
     */
    _setRefreshTimeout() {
        if (this._refreshTimeout) {
            clearTimeout(this._refreshTimeout)
        }
        this._refreshTimeout = setTimeout(this.refresh, this._interval)
    }

}
